export const calculateScriptDuration = (text: string): number => {
  const charsPerSecond = 16.5
  const charsCount = text.replace(/\s+/g, ' ').trim().length
  return charsCount / charsPerSecond
}
